import { ReactComponent as Delete } from "./images/Delete-white.svg";
import { ReactComponent as Search } from "./images/Search.svg";
import people from "./images/people.png";
import trafic from "./images/trafic.jpg";
import plusWhite from "./images/plusWhite.png";
import leftArrow from "./images/leftArrow.png";
import download from "./images/download.svg";
import googleMap from "./images/googleMap.svg";
import clock from "./images/clock.svg";
import SentToPolice from "./images/SentToPolice.svg";
import NotificationLetter from "./images/NotificationLetter.svg";
import DisqualificationReport from "./images/DisqualificationReport.svg";
import SeriousNotificationLetter from "./images/SeriousNotificationLetter.svg";
import exclamationCircle from "./images/exclamationCircle.svg";
import forImmediateTreatment from "./images/forImmediateTreatment.svg";
import filter from "./images/filter.svg";
import calculator from "./images/calculator.svg";
import clipboard from "./images/clipboard.png";
import envelope from "./images/envelope.png";
import shieldExclamation from "./images/shieldExclamation.png";
import chat from "./images/chat.png";
import chatExclamation from "./images/chatExclamation.png";
import person from "./images/person.png";
import controller from "./images/controller.png";
import logo from "./images/logo_sh_text.svg";

export const images = {
  Delete,
  Search,
  people,
  trafic,
  plusWhite,
  leftArrow,
  download,
  googleMap,
  clock,
  SentToPolice,
  NotificationLetter,
  DisqualificationReport,
  SeriousNotificationLetter,
  exclamationCircle,
  forImmediateTreatment,
  filter,
  calculator,
  clipboard,
  envelope,
  shieldExclamation,
  chat,
  chatExclamation,
  person,
  controller,
  logo,
};
